<template>
  <div class="users" id="users">
    <br>
    <center>
      <button class="buttonsubs" style="font-size:20px;padding:10px;margin-right:20px;" @click="stripeshow=true">View/Add Subscriptions</button>
      <button class="buttoncancel" style="font-size:20px;padding:10px;" @click="stripecancelshow=true">Cancel Subscriptions</button>
    </center>
    <br>
    <h3 v-if="!isInd"><span @click="menu(!desktop)">Users </span><span style="font-size:18px;font-weight:normal;">( {{ subscnt[0].available }} available )</span> <span @click="addUser()"></span></h3>
    <div v-if="!isInd" :class="workareaWidth > 900 ? 'user_list' : 'user_list_tablet'">
      <div class="list_header">
        <div>email</div>
        <div v-if="width > 600">First Name</div>
        <div v-if="width > 600">Last Name</div>
        <div v-if="workareaWidth > 900">Groups</div>
        <div>Edit</div>
      </div>
      <div class="list_body" v-for="(user,index) in users" :key="index">
        <template v-if="user.roles.includes('user') && user.restrictedtype!=='unassigned' && user.restrictedtype!=='viewer' && user.restrictedtype!=='kiosk'">
          <div>{{ user.email }}</div>
          <div v-if="width > 600">{{ user.firstName }}</div>
          <div v-if="width > 600">{{ user.lastName }}</div>
          <div class="groups" v-if="workareaWidth > 900">
            <transition v-for="groupId in user.groups">
              <div v-if="groups[groupId] !== undefined">{{ groups[groupId].name }}</div>
            </transition>
          </div>
          <div><span class="edit" @click="editUser(index)"></span></div>
          <div class="groups" v-if="workareaWidth <= 900 && width > 600">
            <span>Groups:</span>
            <transition v-for="groupId in user.groups">
              <div v-if="groups[groupId] !== undefined">{{ groups[groupId].name }}</div>
            </transition>
          </div>
        </template>
      </div>
    </div><br>

    <h3><span @click="menu(!desktop)">Viewers </span><span style="font-size:18px;font-weight:normal;">( {{ subscnt[1].available }} available )</span> <span @click="addViewerUser()"></span></h3>
    <div :class="workareaWidth > 900 ? 'user_list' : 'user_list_tablet'">
      <div class="list_header">
        <div>email</div>
        <div v-if="width > 600">First Name</div>
        <div v-if="width > 600">Last Name</div>
        <div v-if="workareaWidth > 900">Groups</div>
        <div>Edit</div>
      </div>
      <div class="list_body" v-for="(user,index) in users" :key="index">
        <template v-if="user.roles.includes('user') && user.roles.includes('restricted') && user.restrictedtype=='viewer'">
          <div>{{ user.email }}</div>
          <div v-if="width > 600">{{ user.firstName }}</div>
          <div v-if="width > 600">{{ user.lastName }}</div>
          <div class="groups" v-if="workareaWidth > 900">
            <transition v-for="groupId in user.groups">
              <div v-if="groups[groupId] !== undefined">{{ groups[groupId].name }}</div>
            </transition>
          </div>
          <div><span class="edit" @click="editUser(index)"></span></div>
          <div class="groups" v-if="workareaWidth <= 900 && width > 600">
            <span>Groups:</span>
            <transition v-for="groupId in user.groups">
              <div v-if="groups[groupId] !== undefined">{{ groups[groupId].name }}</div>
            </transition>
          </div>
        </template>
      </div>
    </div><br>

    <h3><span @click="menu(!desktop)">Kiosks </span><span style="font-size:18px;font-weight:normal;">( {{ subscnt[2].available }} available )</span> <span @click="addKioskUser()"></span></h3>
    <div :class="workareaWidth > 900 ? 'user_list' : 'user_list_tablet'">
      <div class="list_header">
        <div>email</div>
        <div v-if="width > 600">First Name</div>
        <div v-if="width > 600">Last Name</div>
        <div v-if="workareaWidth > 900">Groups</div>
        <div>Edit</div>
      </div>
      <div class="list_body" v-for="(user,index) in users" :key="index">
        <template v-if="user.roles.includes('user') && user.roles.includes('restricted') && user.restrictedtype=='kiosk'">
          <div>{{ user.email }}</div>
          <div v-if="width > 600">{{ user.firstName }}</div>
          <div v-if="width > 600">{{ user.lastName }}</div>
          <div class="groups" v-if="workareaWidth > 900">
            <transition v-for="groupId in user.groups">
              <div v-if="groups[groupId] !== undefined">{{ groups[groupId].name }}</div>
            </transition>
          </div>
          <div><span class="edit" @click="editUser(index)"></span></div>
          <div class="groups" v-if="workareaWidth <= 900 && width > 600">
            <span>Groups:</span>
            <transition v-for="groupId in user.groups">
              <div v-if="groups[groupId] !== undefined">{{ groups[groupId].name }}</div>
            </transition>
          </div>
        </template>
      </div>
    </div><br>
    <br><br>
    
    <center>
      <h4><span @click="menu(!desktop)">-- Unassigned --</span></h4>
    </center>
    <div  :class="workareaWidth > 900 ? 'user_list' : 'user_list_tablet'">
      <div class="list_header">
        <div style="color:#999;">email</div>
        <div v-if="width > 600" style="color:#999;">First Name</div>
        <div v-if="width > 600" style="color:#999;">Last Name</div>
        <div></div>
        <div style="color:#999;">Edit</div>
      </div>
      <div class="list_body" v-for="(user,index) in users" :key="index">
        <template v-if="user.restrictedtype==='unassigned'">
          <div style="color:#999;"> {{ user.email }}</div>
          <div v-if="width > 600" style="color:#999;">{{ user.firstName }}</div>
          <div v-if="width > 600" style="color:#999;">{{ user.lastName }}</div>
          <div class="groups" v-if="workareaWidth > 900">
            <transition v-for="groupId in user.groups">
              <div v-if="groups[groupId] !== undefined">{{ groups[groupId].name }}</div>
            </transition>
          </div>
          <div><span class="edit" @click="editUser(index)"></span></div>
          <div class="groups" v-if="workareaWidth <= 900 && width > 600">
            <span>Groups:</span>
            <transition v-for="groupId in user.groups">
              <div v-if="groups[groupId] !== undefined">{{ groups[groupId].name }}</div>
            </transition>
          </div>
        </template>
      </div>
    </div><br>

    <br><br>
    

    <stripe 
      :stripeshow="stripeshow"
      @close="SubsAddClose"
    />

    <stripecancel
      :stripecancelshow="stripecancelshow"
      @close="SubsCancelClose"
    />

  </div>
</template>

<script setup>
  import { defineProps, defineEmits, ref, toRefs, watch, onMounted } from 'vue';
  import stripe from '../../components/dialogs/stripe.vue';
  import stripecancel from '../../components/dialogs/stripecancel.vue';
  const stripeshow = ref(false);
  const stripecancelshow = ref(false);
  let props = defineProps({ users: Object, groups: Object, desktop: Boolean, isInd: Boolean, subscnt: Object });
  const { users, groups, desktop } = toRefs(props);
  console.log("USERS---",users.value)
  const emit = defineEmits(['selected', 'addUser', 'appear']);

  function SubsAddClose() {
    stripeshow.value=false;
    emit("updatesubs")
  }

  function SubsCancelClose() {
    stripecancelshow.value=false;
    emit("updatesubs")
  }

  function menu(i) {
    emit('appear',i);
  }
  function editUser(i) {
    emit('selected',i);
  }
  function addUser(i) {
    emit('addUser',i);
  }

  function addViewerUser(i) {
    emit('addViewerUser',i);
  }

  function addKioskUser(i) {
    emit('addKioskUser',i);
  }

  let workareaWidth = ref();
  let width = ref(window.innerWidth)
  onMounted(() => {
    workareaWidth.value = document.getElementById('users').offsetWidth;
    width.value = window.innerWidth;
    window.addEventListener('resize', () => {
      workareaWidth.value = document.getElementById('users').offsetWidth;
      width.value = window.innerWidth;
    });
  });

  watch(() => props.users, (newValue) =>
  {
    users.value = newValue;
    console.log("users",users.value)
  }, { deep: true });

  watch(() => props.groups, (newValue) =>
  {
    groups.value = newValue;
  }, { deep: true });
</script>

<style lang="scss" scoped>
  .buttonsubs {
    border-radius: 10px;
    color:#1a1a1a;
    background-color:white;
    padding:10px;
    margin:6px;
    border: 1px #414141 solid; 
    cursor:pointer;
    text-align: center;
  }
  .buttoncancel {
    border-radius: 10px;
    color:#1a1a1a;
    background-color:white;
    padding:10px;
    margin:6px;
    border: 1px #414141 solid; 
    cursor:pointer;
    text-align: center;
  }
  .viewerlic {
    border:1px #aaa solid;
    border-radius: 10px;
    background-color: #eee;
    color:#777;
    margin-left: 4px;
    padding-left:8px;
    padding-right:8px;
    font-size: 16px;
  }
  .users{
    .user_list{
      padding: 20px 20px 0 20px;
      .list_header{
        font-weight: 500;
      }
      >div{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        color: #444;
        border-bottom: 1px solid #bcbcbc;
        >div{
          padding: 8px 0;
          display: flex;
          align-items: center;
        }
        .groups{
          >div{
            height: 37px;
            line-height: 35px;
            border: 1px solid #bcbcbc;
            border-radius: 8px;
            padding: 0 16px;
            background-color: #f2f2f2;
            font-size: 1rem;
            margin: 2px;
            box-sizing: border-box;
          }
        }

        >div:nth-child(1){
          width: 33%;
          word-break: break-word;
          white-space: nowrap;
        }
        >div:nth-child(2){
          width: 15%;
        }
        >div:nth-child(3){
          width: 15%;
        }
        >div:nth-child(4){
          width: 30%;
          display: flex;
          flex-wrap: wrap;
        }
        >div:nth-child(5){
          width: 7%;
          justify-content: center;
          .edit{
            width: 30px;
            height: 30px;
            background-repeat: no-repeat;
            background-size: 100%;
            background-position: center;
            background-image: url(../../../public/img/edit.svg);
            cursor: pointer;
          }
        }
      }
    }
    .user_list_tablet{
      padding: 20px 20px 0 20px;
      .list_header{
        font-weight: 500;
      }
      >div{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        color: #444;
        border-bottom: 1px solid #bcbcbc;
        flex-wrap: wrap;
        >div{
          padding: 8px 0;
          display: flex;
          align-items: center;
          
          .edit{
            width: 30px;
            height: 30px;
            background-repeat: no-repeat;
            background-size: 100%;
            background-position: center;
            background-image: url(../../../public/img/edit.svg);
            cursor: pointer;
          }
        }
        .groups{
          >div{
            height: 37px;
            line-height: 35px;
            border: 1px solid #bcbcbc;
            border-radius: 8px;
            padding: 0 16px;
            background-color: #f2f2f2;
            font-size: 1rem;
            margin: 2px;
            box-sizing: border-box;
          }
          >span{
            // display: inline-block;
            margin-right: 10px;
          }
        }

        >div:nth-child(1){
          width: 42%;
          word-break: break-word;
          white-space: nowrap;
          @media screen and (max-width: 600px){
            width: calc(100% - 50px);
          }
        }
        >div:nth-child(2){
          width: 25%;
          @media screen and (max-width: 600px){
            width: 50px;
          }
        }
        >div:nth-child(3){
          width: 25%;
        }
        >div:nth-child(4){
          width: 8%;
          justify-content: center;
        }
        >div:nth-child(5){
          width: 100%;
          display: flex;
          flex-wrap: wrap;
        }
      }
    }
    h3{
      height: 60px;
      line-height: 60px;
      margin: 0px;
      padding: 0 0 0 20px;
      background-color: #f2f2f2;
      position: relative;
      span:last-child{
        height: 30px;
        width: 30px;
        display: inline-block;
        position: absolute;
        top: 50%;
        right: 15px;
        transform: translateY(-50%);
        background-repeat: no-repeat;
        background-size: 24px;
        background-position: center;
        background-image: url(../../../public/img/plus_gray.svg);
        cursor: pointer;
      }
      @media screen and (max-width: 900px){
        span:first-child{
          display: inline-block;
          height: 100%;
          padding-right: 40px;
          background-image: url(../../../public/img/arr_down.svg);
          background-repeat: no-repeat;
          background-position: center right;
        }
      }
    }
    h4{
      height: 40px;
      line-height: 40px;
      font-size:18px;
      margin: 0px;
      padding: 0 0 0 20px;
      background-color: #f2f2f2;
      color:#999;
      position: relative;
      @media screen and (max-width: 900px){
        span:first-child{
          display: inline-block;
          height: 100%;
          padding-right: 40px;
          background-image: url(../../../public/img/arr_down.svg);
          background-repeat: no-repeat;
          background-position: center right;
        }
      }
    }
  }
</style>